import { writable } from 'svelte/store';

export const uiStore = writable({
  isPasswordProtected: false,
  isSearchOpen: false,
});

export function openSearchModal() {
  uiStore.update((values) => ({
    ...values,
    isSearchOpen: true,
  }));
}

export function closeSearchModal() {
  uiStore.update((values) => ({
    ...values,
    isSearchOpen: false,
  }));
}
